export type CaveTextureKey = "cave-far" | "cave-mid" | "cave-near";

export interface CaveView {
  distance: number;
  widthRatio: number;
  plantOffsetY: number;
  key: CaveTextureKey;
  alpha: number;
}

/**
 * Keep the cave on the horizon as a destination. It must not travel down
 * the playable road or grow wider than the vanishing-point mound.
 */
export function caveViewForProgress(progress: number): CaveView {
  const t = Math.max(0, Math.min(1, (progress - 0.5) / 0.5));
  const eased = t * t;
  return {
    distance: 0.9 - eased * 0.14,
    widthRatio: 0.16 + eased * 0.22,
    plantOffsetY: 8,
    key: progress > 0.82 ? "cave-near" : progress > 0.55 ? "cave-mid" : "cave-far",
    alpha: Math.min(1, 0.22 + progress * 0.7),
  };
}
